import { Injectable } from '@angular/core';
import * as socketIO from 'socket.io-client';
import Socket = SocketIOClient.Socket;
import { localStorageKeys } from '../common/constants/local.storage.keys';
import { ConfigService } from './config.service';

@Injectable()
export class AdminSocketService {
  public socket: Socket;

  public init() {
    if (!this.socket) {
      const authToken = localStorage.getItem(localStorageKeys.authToken) || '';
      const token = authToken.replace(/^Bearer\s+/i, '');
      this.socket = socketIO(ConfigService.config.socketIOAddress, {
        query: { token },
      });
    }
  }

  public close() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket = null;
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/admin.socket.service.ts